import { Component, OnInit } from '@angular/core';
import { Configuration } from '@shared/models/configuration';
import { CreateWorkflowAction } from '../../../workflow/store/workflow.actions';
import { select, Store } from '@ngrx/store';
import { IWorkflowCollectionState } from '../../../workflow/store/workflow.reducer';
import { isWorkflowCleanedUp } from '../../../workflow/store/workflow.selector';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { Guid } from 'guid-typescript';

@Component({
    standalone: false,
    selector: 'particle-filing-manager-form-workflow',
  templateUrl: './create-form-workflow.component.html',
  styleUrls: ['./create-form-workflow.component.scss']
})
export class CreateFormWorkflowComponent implements OnInit {
  workflowId:string;
  apiEndpointKey:string;
  workflowTemplateId: string;
  cleanedUp$:any;
  unsubscribe$ = new Subject<void>();
  private formTemplateId: string;
  private arrangementId: string;
  constructor(protected activatedRoute: ActivatedRoute,private store: Store<IWorkflowCollectionState>, private router: Router,private route: ActivatedRoute) {
    this.workflowId = Guid.create().toString();
    this.workflowTemplateId = "create-form-ui-workflow";
    this.formTemplateId="";
    this.apiEndpointKey = "Dac6Api";
  }

  ngOnInit() {
    this.activatedRoute.params.pipe(takeUntil(this.unsubscribe$)).subscribe((params: any) => {
      if (params) {
        this.formTemplateId = params.formTemplateId;
        this.arrangementId = params.arrangementId;
      }
    });
    const url = `${Configuration.getConfig( this.apiEndpointKey)}Command/CreateWorkflow`;
    const action = new CreateWorkflowAction(url, this.workflowId, 'filing manager form ui workflow', this.workflowTemplateId, false);
    //const currentDate = new Date();
    action.setParameters({
      'FORM_TEMPLATE_ID': this.formTemplateId,
      'Arrangement_Id': this.arrangementId,
    });
    this.store.dispatch(action);
    this.cleanedUp$ = this.store.pipe(select(isWorkflowCleanedUp, this.workflowId));
    this.cleanedUp$.pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
      if (state === 'Finished' || state === 'Cancelled') {
        this.router.navigateByUrl(`dac6-reporter/filing-manager/forms`);
      }
    });
  }

}
